import { render, staticRenderFns } from "./PhaseField.vue?vue&type=template&id=a319e068"
import script from "./PhaseField.vue?vue&type=script&lang=js"
export * from "./PhaseField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports